export default "__VITE_ASSET__KA4pXu$R__"